import React from 'react';
import { iconSizer } from "../../../../icons2022/iconSizer";
import { MinusCircleIcon16Light } from "../../../../icons2022/MinusCircleIcon/MinusCircleIcon16Light";
import { MinusCircleIcon20Light } from "../../../../icons2022/MinusCircleIcon/MinusCircleIcon20Light";
import { MinusCircleIcon24Regular } from "../../../../icons2022/MinusCircleIcon/MinusCircleIcon24Regular";
export var ErrorIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(MinusCircleIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(MinusCircleIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(MinusCircleIcon24Regular, null);
  }
}, 'ErrorIcon');